// ======================================================================
// File Name       : ContentVideoPlayer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import $ from 'jquery';
import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';
import { htmlEntities } from '../../utils';

class ContentVideoPlayer extends React.Component {
  componentDidUpdate() {
    const { videoUrl } = this.props;
    const video = videoUrl.videoPlayer ? htmlEntities(videoUrl.videoPlayer) : null;
    if (this.props.showModal) {
      if (video) {
        this.props.onOpenVideoPlayer();
        this.timer = setInterval(() => {
          // #6420 START
          if (document.getElementById("spiner") && document.getElementById("spiner").style) {
            document.getElementById("spiner").style.display = "none";
            // #6420 END
            clearInterval(this.timer);
            // Step 15.2.0 #24660 START
            const parser = new DOMParser();
            const doc = parser.parseFromString(video, 'text/html');

            const container = document.getElementById('video-container');

            doc.body.childNodes.forEach(node => {
              if (node.nodeName === 'SCRIPT') {
                const script = document.createElement('script');

                if (node.src) {
                  script.src = node.src;
                }

                script.type = node.type || 'text/javascript';

                container.appendChild(script);
              } else {
                container.appendChild(document.importNode(node, true));
              }
            });
            // Step 15.2.0 #24660 END
          }
        }, 100);
      }
    }
  }

  render() {
    const isIE = /*@cc_on!@*/false || !!document.documentMode;
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        onHide={this.props.onCloseVideo}
        size={this.props.bsSize}
        style={this.props.style}
        dialogClassName="video-player-dialog"
        keyboard={!isIE}
      >
        <Modal.Body>
          {!this.props.videoUrl.videoPlayer && (<span className="bi bi-arrow-clockwise refresh-animate" id="spiner"/>)}
          <div id="video-container" />
        </Modal.Body>
        <Modal.Footer>
          <Form.Group className="text-center">
            <Button variant="primary" className="btn-96" onClick={this.props.onCloseVideo}>
              閉じる
            </Button>
          </Form.Group>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ContentVideoPlayer;
